module.exports = __webpack_public_path__ + "img/classifiers.f273b3aa.svg";